export default __webpack_public_path__ + "static/media/Bench.b3f20677.png";